'use client';

import { PrivyProvider } from '@privy-io/react-auth';
import { WagmiProvider } from '@privy-io/wagmi';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { queryClient } from 'mode-shared/configs/query';
import { wagmiConfig } from 'mode-shared/utils/wagmi';
import config from 'mode-shared/configs/config';
import { privyConfig } from 'mode-shared/utils/privy';

export const WalletConnectorProvider = ({ children }: { children: ReactNode }) => {
  return (
    <PrivyProvider appId={config.privyAppId} config={privyConfig}>
      <QueryClientProvider client={queryClient}>
        <WagmiProvider config={wagmiConfig}>{children}</WagmiProvider>
      </QueryClientProvider>
    </PrivyProvider>
  );
};
